import { constant, get, getOr } from 'lodash/fp';
import { createStructuredSelector, createSelector } from 'reselect';

import { FAVORITE_TYPE_LIKE, FAVORITE_TYPE_DISLIKE } from './constants';

const getAds = get(['favoritesOverview', 'ads', 'result']);
const getCms = get(['favoritesOverview', 'cms', 'result']);
const getFavoriteType = get(['favoritesOverview', 'ui', 'favoriteType']);

const getLikeCount = createSelector(getAds, get(['likeCount']));
const getDislikeCount = createSelector(getAds, get(['dislikeCount']));

const getNoResultsBlockProps = createSelector(
  getCms,
  getFavoriteType,
  (cmsResult, favoriteType) => {
    const isDislike = favoriteType === FAVORITE_TYPE_DISLIKE;
    const cmsHtml = get(
      [isDislike ? 'dislikes-noresults-content' : 'noresults-content'],
      cmsResult,
    );

    return {
      cmsHtml,
      isDislike,
    };
  },
);

const getBreadcrumbs = constant([
  { text: __('favorites.overview.breadcrumbs.text') },
]);

const getHead = createSelector(
  getCms,
  createStructuredSelector({
    title: getOr(__('search.page.defaultHtmlTitle'), ['html-title']),
    description: getOr(__('search.page.defaultMetaDescription'), [
      'meta-description',
    ]),
    robots: get(['meta-robots']),
  }),
);

const getAdListProps = createSelector(
  getAds,
  getFavoriteType,
  (ads, favoriteType) => ({
    items: get(['items'], ads),
    pagination: get(['pagination'], ads),
    withFavorite: favoriteType === FAVORITE_TYPE_LIKE,
    withDislike: favoriteType === FAVORITE_TYPE_DISLIKE,
  }),
);

const getShowAdList = createSelector(
  getAds,
  getFavoriteType,
  ({ likeCount, dislikeCount }, favoriteType) =>
    Boolean(favoriteType === FAVORITE_TYPE_LIKE ? likeCount : dislikeCount),
);

const getIsLoading = get(['favoritesOverview', 'ads', 'isLoading']);

export default createStructuredSelector({
  favoriteType: getFavoriteType,
  likeCount: getLikeCount,
  dislikeCount: getDislikeCount,
  noResultsBlockProps: getNoResultsBlockProps,
  breadcrumbs: getBreadcrumbs,
  head: getHead,
  adListProps: getAdListProps,
  isLoading: getIsLoading,
  showAdList: getShowAdList,
});
